import { Component, OnInit, Input, ViewChild, SimpleChanges, forwardRef } from '@angular/core';
import { 
    IonPopover, IonDatetime, IonLabel, IonIcon, IonButtons, IonButton 
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { MarvDateToStringPipe } from '@marv/pipes';
import { MarvSpeechToTextComponent } from '@marv/components'; 
import { MarvDateService } from '@marv/services';

@Component({
    selector: 'marv-month-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [
        IonPopover, IonDatetime, IonLabel, IonIcon, IonButtons, IonButton, TranslatePipe, ReactiveFormsModule, MarvDateToStringPipe, 
        forwardRef(() => MarvSpeechToTextComponent)
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class MarvMonthSelectComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'fixedLabel', required : false}) fixedLabel: boolean = false;
    @Input({alias : 'icon', required : false}) iconInput: string = 'calendar-outline';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MSG_ERROR_SELECT_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;

    @ViewChild('popoverMonthDate') popoverMonthDate: IonPopover;
    @ViewChild('monthDate') monthDate: IonDatetime;
    @ViewChild('marvSpeechToText') marvSpeechToText: MarvSpeechToTextComponent;
    
    isRequired: boolean = false;
    
    updateStatusChange: Subscription;
    
    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        });
    }
    
    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
        
    ngOnDestroy() {           
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
    }

    selectMonth($event: any){
        if($event.detail?.value){
            this.formGroupDirective.form.controls[this.formName].setValue(new Date($event.detail.value));
            this.closeMonthPicker();
        }
    }

    closeMonthPicker(){
        this.popoverMonthDate.dismiss();
    }
    
    speechToText($event: any){
        $event.stopPropagation();  
        if(!this.disabled){
            this.marvSpeechToText.open();
        }
    }
    
    onDismissSpeechToText(text: string){
        if(text !== '' && this.formGroupDirective.form.controls[this.formName]){
            let date = MarvDateService.ParseFromString(text);
            if(date){
                this.formGroupDirective.form.controls[this.formName].setValue(MarvDateService.GetFirstDayOfMonth(date));
            }
        }
    }
}
